"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectValidationData = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const selectors_1 = require("astra-core/containers/AccountProvider/selectors");
const selectors_2 = require("astra-core/containers/CommonDataProvider/selectors");
exports.selectValidationData = (0, toolkit_1.createSelector)([selectors_2.selectCurrencyMinBet, selectors_1.selectAccountBalance], (minBet, balance) => {
    return {
        minBet,
        balance
    };
});
//# sourceMappingURL=index.js.map